import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const NumberInput = ({
  value,
  onChange,
  placeholder,
  type = 'number',
  step = 1,
  precision = 0,
  prefix,
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <InputNumber
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      step={step}
      precision={precision}
      prefix={prefix}
      style={{
        width: '100%',
        backgroundColor: theme.background,
        color: theme.textSecondary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

NumberInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  step: PropTypes.number,
  precision: PropTypes.number,
  prefix: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default NumberInput; 